import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-skiptest-popup',
    templateUrl: './skiptest-popup.component.html',
    styleUrls: ['./skiptest-popup.component.scss'],
    standalone: false
})
export class SkiptestPopupComponent implements OnInit {

  skipTest = true;

  constructor(public matdialogRef: MatDialogRef<SkiptestPopupComponent>) {};

  ngOnInit(): void {
  }

  submit(): void {
    this.matdialogRef.close({skipTest: this.skipTest});
  }

  cancel(): void {
    this.matdialogRef.close();
  }

  executeTest(val): void {
    this.skipTest = val;
  }

}

